<script setup>
import { ref, watch } from 'vue';
import Button from 'next/button/Button.vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';
import Switch from 'next/switch/Switch.vue';

const props = defineProps({
  tool: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['clone', 'edit', 'delete', 'toggleActive']);

const toolActive = ref(props.tool.active);

watch(
  () => props.tool,
  ({ active }) => {
    toolActive.value = active;
  }
);
</script>

<template>
  <div
    class="flex items-center gap-4 px-6 py-4 transition-colors cursor-pointer hover:bg-n-alpha-1"
    @click="emit('edit')"
  >
    <div
      class="size-9 flex-shrink-0 rounded-lg bg-n-alpha-3 flex items-center justify-center"
    >
      <Icon icon="i-lucide-wrench" class="size-4 text-n-slate-11" />
    </div>

    <div class="flex flex-col gap-0.5 flex-1 min-w-0">
      <span class="text-heading-3 text-n-slate-12 truncate">
        {{ tool.name }}
      </span>
      <span class="text-body-main text-n-slate-11 truncate">
        {{ tool.description }}
      </span>
    </div>

    <div class="flex items-center gap-2 flex-shrink-0" @click.stop>
      <Switch v-model="toolActive" @change="emit('toggleActive', $event)" />

      <div class="mx-1 w-px h-4 bg-n-weak" />

      <Button
        v-tooltip.top="$t('WGPT_MCP_SERVERS.EDIT.TOOLS.TOOLTIP.EDIT')"
        icon="i-woot-edit-pen"
        slate
        sm
        @click="emit('edit')"
      />
      <Button
        v-tooltip.top="$t('WGPT_MCP_SERVERS.EDIT.TOOLS.TOOLTIP.CLONE')"
        icon="i-woot-clone"
        slate
        sm
        @click="emit('clone')"
      />
      <Button
        v-tooltip.top="$t('WGPT_MCP_SERVERS.EDIT.TOOLS.TOOLTIP.DELETE')"
        icon="i-woot-bin"
        slate
        sm
        class="hover:enabled:text-n-ruby-11 hover:enabled:bg-n-ruby-2"
        @click="emit('delete')"
      />
    </div>
  </div>
</template>
